// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aWOOaiaEeSgDfa84AAD3{flex-direction:column;width:100%;height:100%;display:flex;position:relative}.Jx0lf4NyOIieyAeuteub{width:116px;line-height:normal;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerListContentContainer": `aWOOaiaEeSgDfa84AAD3`,
	"helpButton": `Jx0lf4NyOIieyAeuteub`
};
export default ___CSS_LOADER_EXPORT___;
